module.exports = __webpack_public_path__ + "static/COVER_orange-73a857a74598743985764950842b9c5d.jpeg";